module.exports = __webpack_public_path__ + "images/imgLoader.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/reusableComponents/ImageGallery/imgLoader.gif
// module id = 2500
// module chunks = 0